import React, {useState} from 'react'
import './LoginStyle.css'
import logo from '../../Assets/Logo-pal.png'
import {useNavigate} from "react-router-dom"; 
import { PostAPI } from '../../common/Api';
import { ToastContainer, toast } from 'react-toastify';
function Loginmodule() {
    const navigate = useNavigate()
    const [email,setEmail] = useState('');
    const [password,setPassword] = useState('');
    const checkLogin = (e) => {
        let formData= new FormData();
        e.preventDefault();
        
        if(email == '' || password == ''){
            toast.error('Email and password is required')
        }else{
            formData.append('email',email);
            formData.append('password',password);
            var apiData = {
                url:'counsellor_login_main',
                data:formData
            }
            PostAPI(apiData, (res)=>{
                if(res && res.status){
                    sessionStorage.setItem('login_details',JSON.stringify(res.data))
                    navigate("/dashboard");
                }else{
                    toast.error(res.message)
                    console.log('====',res)
                 
                }
            } )
        }

        

    }


    return (
        <div className='container LoginHeadr'>
            <div><img className='Comn_logo' src={logo}/></div>
        

            <div className='Login_main'>
                <form className='myForm' onSubmit={(e) => checkLogin(e)}>
                    <div> <p className='Login-title'>
                        Counsellor Log In
                    </p>
                    </div>




                    <div>
                        <div className='In_names'> <input className='Name_valn' type="text" placeholder="Email ID" name="uname" onChange={(e) => setEmail(e.target.value)} value={email}  /></div>



                        <div className='In_names'> <input className='Name_valpaswd' type="password" placeholder="Enter Password" name="psw" onChange={(e) => setPassword(e.target.value)} value={password}  /></div>
                        

                        {/* <Link to="/dashboard" className="In_names"> */}
                        <div className=''> <button className='Name_btlogin' type="submit">Login</button></div>

                        {/* </Link> */}


                    </div>


                </form>
            </div>
            <ToastContainer />
        </div>
    )
}

export default Loginmodule